module.exports = __webpack_public_path__ + "assets/a-8-DNA.f6ab6bc3.svg";